export const incomeTypes = {
  preschoolsFees: 'Preschool Fee',
  startupSupport: 'Startup Support',
  donationsOrVouchers: 'Donation',
  dsdSubsidy: 'DBE Subsidy',
  otherIncome: 'Other',
};

export interface AddIncomeItemState {
  incomeItem: IncomeItem;
  isEdit: boolean;
}

export interface IncomeItem {
  incomeTypeId: string;
  id: string;
  dateReceived: string;
  amount: number;
  childUserId: string;
  notes: string;
  description: any;
  amountExpected: number;
  childCoverAmount: number;
  payTypeId: any;
  contributionTypeId: string;
  photoProof: any;
  feeTypeId: string;
}
